import { quoteSmsHref } from '../lib/contact';

export function bindDesignInteractions(root) {
  const cleanups = [];
  root.querySelectorAll('.mobile-text-link').forEach(link => {
    // iOS and Android use different separators for an SMS body.
    link.href = quoteSmsHref();
  });
  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  root.querySelectorAll('.rotating-banner').forEach(banner => {
    const panels = Array.from(banner.querySelectorAll('.banner-panel'));
    const button = banner.querySelector('.banner-toggle');
    let current = 0;
    let paused = Boolean(reducedMotion);
    let hovering = false;
    let focused = false;
    const showNext = () => {
      current = (current + 1) % panels.length;
      panels.forEach((panel, i) => { panel.hidden = i !== current; });
    };
    const updateButton = () => {
      button.textContent = reducedMotion ? '↔' : paused ? '▶' : 'Ⅱ';
      button.setAttribute('aria-label', reducedMotion ? 'Show next banner' : paused ? 'Play rotating banner' : 'Pause rotating banner');
      button.setAttribute('aria-pressed', String(paused));
    };
    const toggle = () => { if (reducedMotion) showNext(); else paused = !paused; updateButton(); };
    const enter = () => { hovering = true; };
    const leave = () => { hovering = false; };
    const focus = () => { focused = true; };
    const blur = event => { if (!banner.contains(event.relatedTarget)) focused = false; };
    updateButton();
    const timer = window.setInterval(() => {
      if (!paused && !hovering && !focused && !document.hidden) showNext();
    }, 6000);
    const events = [['pointerenter', enter], ['pointerleave', leave], ['focusin', focus], ['focusout', blur]];
    events.forEach(([name, handler]) => banner.addEventListener(name, handler));
    button.addEventListener('click', toggle);
    cleanups.push(() => {
      window.clearInterval(timer);
      events.forEach(([name, handler]) => banner.removeEventListener(name, handler));
      button.removeEventListener('click', toggle);
    });
  });
  root.querySelectorAll('.cta').forEach(section => {
    const button = section.querySelector('.button');
    if (!button) return;
    let frame;
    const glow = event => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(() => {
        const rect = button.getBoundingClientRect();
        const distance = Math.hypot(Math.max(rect.left - event.clientX, 0, event.clientX - rect.right), Math.max(rect.top - event.clientY, 0, event.clientY - rect.bottom));
        section.style.setProperty('--quote-glow', String(Math.max(0, 1 - distance / 340)));
      });
    };
    const reset = () => { window.cancelAnimationFrame(frame); section.style.setProperty('--quote-glow', '0'); };
    const focus = () => { section.style.setProperty('--quote-glow', '1'); };
    section.addEventListener('pointermove', glow);
    section.addEventListener('pointerleave', reset);
    button.addEventListener('focus', focus);
    button.addEventListener('blur', reset);
    cleanups.push(() => {
      reset();
      section.removeEventListener('pointermove', glow);
      section.removeEventListener('pointerleave', reset);
      button.removeEventListener('focus', focus);
      button.removeEventListener('blur', reset);
    });
  });
  return () => cleanups.forEach(cleanup => cleanup());
}
